module.exports = __webpack_public_path__ + "img/zuopingzhanshi.562c1468.png";